export class MapToolMovil {
    public cod_equipo_rastreo: string;
    public des_equipo_rastreo: string;
    public checked: boolean;
    public latitud: string;
    public longitud: string;
    constructor(data: any) {
        this.cod_equipo_rastreo = data.cod_equipo_rastreo;
        this.des_equipo_rastreo = data.des_equipo_ratreo;
        this.checked = true;
        this.latitud = data.ult_latitud;
        this.longitud = data.ult_longitud;
    }
}